import * as ActionTypes from '../store/ActionTypes';
import { axiosInstance } from './api';

export const actionCreators = {
    getTimeZones: (timezones) => ({type: ActionTypes.getTimeZones, payload:timezones}),
};

export const getTimeZones = (callback, context) => {
    return dispatch => {
            const url = `timeZone/GetAllAsync`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getTimeZones(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}